export const sendIssue = (data) => (dispatch) => {
    const csrfToken = document.head.querySelector("[name~=csrf-token][content]").content;

    dispatch({
        type: 'FORM_SENDING'
    });

    fetch('/api/store-issue', {
        headers: {
            "Accept": "application/json",
            "X-CSRF-Token": csrfToken
        },
        method: "POST",
        body: jsonToFormData(data)
    }).then((response) => {
        if (response.status === 201) {
            dispatch({
                type: 'FORM_SENT'
            });

        } else if (response.status === 422) {
            let data = response.json();
            data.then((value) => {
                dispatch({
                    type: 'VALIDATION_ERROR',
                    payload: value.errors
                });
            });
        } else if (response.status === 500) {
            dispatch({
                type: 'CANCEL_LOADING'
            });
            alert(response.statusText);
        }
    })
}

const jsonToFormData = (data) => {
    const formData = new FormData();
    buildFormData(formData, data);

    return formData;
}

const buildFormData = (formData, data, parentKey) => {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
            buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
        });
    } else {
        const value = data == null ? '' : data;

        formData.append(parentKey, value);
    }
}

